import { Grid } from 'antd'

import { useSiderContext } from './sider/context'

/**
 * Horizontal space the fixed app sider occupies, in raw CSS px.
 *
 * The sider is chrome shared by every role and is deliberately left at the base
 * scale, so these are NOT run through any of the per-feature scaling helpers.
 *
 * Single source of truth for the two places that must agree on it: the shell,
 * which offsets the routed content by this much (`layout/index.tsx`), and any
 * `position: fixed` bar inside that content, which resolves against the
 * viewport and therefore has to re-apply the offset itself.
 */
export const SIDER_WIDTH_EXPANDED = 200
export const SIDER_WIDTH_COLLAPSED = 80

/** How wide the sider currently is — 0 when it is not on screen at all. */
export const useSiderOffset = (): number => {
  const breakpoint = Grid.useBreakpoint()
  // `lg` is undefined until the first measurement; treat that as desktop, the
  // same way the shell does, so the content does not jump on first paint.
  const isMobile = typeof breakpoint.lg === 'undefined' ? false : !breakpoint.lg
  const { collapsed } = useSiderContext()

  if (isMobile) return 0
  return collapsed ? SIDER_WIDTH_COLLAPSED : SIDER_WIDTH_EXPANDED
}
